export default {
	tongguowomendewangzhan: '私たちのウェブサイトを通じて',
	rangninyongyoubuyiyangdetiyan: '異なる外出体験をお持ちいただけます。',
	huanyingguanglin: 'ようこそ！私たちの目標は、あなたの理想の旅行を現実にすることです。当プラットフォームは、リーズナブルな価格で航空券やホテルの旅行プランを提供し、完璧な旅行計画を実現することを目指しています。',
	womenjianxin: '私たちは、当サイトを通じて誰もが思い出深い旅行体験を得られると信じており、美しい思い出を残す手助けをさせていただきます。同時に、お客様のすべての取引が安全で信頼性があり、お悩み事が解決されるよう力を尽くしています。',
	wulunzhoumo: '週末のレジャーも、長距離の旅行も、私たちはあなたに理想的な旅行計画とプランを提供するお手伝いをいたします。一緒に体験を始めましょう！',
	weishenmexuanze: 'なぜ私たちを選ぶか',
	duozhongluxingxuanze: '多様な選択肢',
	duozhongluxingxuanzemiaoshu: '私たちはさまざまな選択肢を提供し、異なるニーズ、好み、予算に応えます。経済的な宿泊から豪華なリゾートまで、誰にでも合った選択肢があります。',
	yonghuyouhaodeyudingliucheng: '簡易的予約プロセス',
	yonghuyouhaodeyudingliuchengmiaoshu: '私たちの予約プロセスはユーザーフレンドリーで、手続きが簡略化されています。顧客はオンラインで簡単に旅行の検索と予約ができ、数回のクリックだけで済みます。',
	gexinghuatuijian: 'カスタマイズ',
	gexinghuatuijianmiaoshu: '私たちは顧客の旅行の好みと過去の予約履歴に基づいて個別のおすすめを行います。これにより、特定の要望やニーズに対応したカスタマイズされたツアーを提供できます。',
	kekaodekehufuwu: '信頼性のあるカスタマーサービス',
	kekaodekehufuwumiaoshu: '旅行計画が予測不能であることを理解していますので、変更や問題の処理をサポートする信頼性のあるカスタマーサービスを提供しています。サポートチームは平日午前9時から夜7時まで、顧客にサービスを提供しています。',
	fengfudechanpindiliandejiage: '豊富な製品と低価格',
	fengfudechanpindiliandejiagemiaoshu: 'デルのWebサイトは、世界中の製品資源を集め、豊富な安価な製品を提供し、旅行の好みに合わせてカスタマイズされたサービスを提供しています。',
	anquankekaodejiaoyi: '安全で信頼性の高い取引',
	anquankekaodejiaoyimiaoshu: 'デルは最新のテクノロジーを使用して、取引の安全性と信頼性を確保しています。デルは、お客様の個人情報の漏洩を回避するために、お客様のプライバシー情報の保護に努めています。'
};
